var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdvantages4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3296 25.9288C58.798 25.9288 43.7236 40.8826 43.7236 59.266C43.7236 77.6468 58.798 92.6031 77.3296 92.6031C95.8587 92.6031 110.936 77.6468 110.936 59.266C110.936 40.8826 95.8587 25.9288 77.3296 25.9288ZM77.3296 85.1948C62.9164 85.1948 51.1916 73.5614 51.1916 59.266C51.1916 44.968 62.9164 33.3371 77.3296 33.3371C91.7403 33.3371 103.468 44.968 103.468 59.266C103.468 73.5614 91.7403 85.1948 77.3296 85.1948Z",
    fill: "#58A291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5646 43.2148H37.5006C39.5622 43.2148 41.2346 41.5558 41.2346 39.5106C41.2346 37.4655 39.5622 35.8065 37.5006 35.8065H22.5646C20.5029 35.8065 18.8306 37.4655 18.8306 39.5106C18.8306 41.5558 20.5029 43.2148 22.5646 43.2148Z",
    fill: "#58A291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2346 79.0213C41.2346 76.9761 39.5622 75.3171 37.5006 75.3171H22.5646C20.5029 75.3171 18.8306 76.9761 18.8306 79.0213C18.8306 81.0664 20.5029 82.7254 22.5646 82.7254H37.5006C39.5622 82.7254 41.2346 81.0664 41.2346 79.0213Z",
    fill: "#58A291"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2557 59.266C36.2557 57.2208 34.5834 55.5619 32.5217 55.5619H12.607C10.5454 55.5619 8.87305 57.2208 8.87305 59.266C8.87305 61.3112 10.5454 62.9701 12.607 62.9701H32.5217C34.5834 62.9701 36.2557 61.3112 36.2557 59.266Z",
    fill: "#58A291"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7469 41.8462C76.6853 41.8462 75.0129 43.5051 75.0129 45.5503V60.1619L68.4032 65.0804C66.6911 66.3547 66.4073 68.7935 67.7814 70.4213C69.0555 71.9301 71.2963 72.1869 72.884 71.0065L80.9863 64.9797C81.9273 64.2799 82.4809 63.181 82.4809 62.0144V45.5503C82.4809 43.5051 80.8081 41.8462 78.7469 41.8462Z",
    fill: "#58A291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvantages4);
export default __webpack_public_path__ + "static/media/icon-advantages-4.ade12051d6c968ba6ce009540fdb14a8.svg";
export { ForwardRef as ReactComponent };